import React from 'react';
import * as d3 from 'd3';
import Arrow from './Defs/Arrow';
import { Context } from './Context';
import { committees } from '../fixtures/committees';
import RadialTidyTree from './RadialTidyTree';

class Graph extends React.Component {
  id = this.props.path ? 'force-path' : 'force';

  drag = (simulation) => {
    function dragstarted(d) {
      if (!d3.event.active) simulation.alphaTarget(0.3).restart();
      d.fx = d.x;
      d.fy = d.y;
    }

    function dragged(d) {
      d.fx = d3.event.x;
      d.fy = d3.event.y;
    }

    function dragended(d) {
      if (!d3.event.active) simulation.alphaTarget(0);
      d.fx = null;
      d.fy = null;
    }

    return d3
      .drag()
      .on('start', dragstarted)
      .on('drag', dragged)
      .on('end', dragended);
  };

  simulate() {
    const line = d3
      .line()
      .x((d) => {
        return d[0];
      })
      .y((d) => {
        return d[1];
      })
      .curve(d3.curveLinear);

    const {
      w,
      h,
      data: { nodes, links },
      containerId
    } = this.context;

    const { path } = this.props;

    this.simulation = d3
      .forceSimulation(nodes)
      .force('link', d3.forceLink(links).id((d) => d.id))
      .force('charge', d3.forceManyBody().strength(this.props.path ? -15 : -10))
      .force('centerX', d3.forceX(w / 2).strength(0.1))
      .force('centerY', d3.forceY(h / 2).strength(0.1))
      .force('center', d3.forceCenter(w / 2, h / 2 + 60));

    const svg = d3.select(`#${this.id}`);

    const link = svg
      .append('g')
      .attr('stroke', '#3d8feb')
      .selectAll('line')
      .data(links)
      .join('line')
      .attr('stroke-opacity', path ? 0.15 : 0.25)
      .attr('stroke-width', 1)
      .style('pointer-events', 'none');
    const nodeGroup = svg
      .append('g')
      .attr('stroke', 'none')
      .selectAll('g')
      .data(nodes)
      .join('g');

    const shortestPath =
      path &&
      svg
        .append('g')
        .selectAll('path')
        .data(
          committees
            .filter((el, i) => i < committees.length - 1)
            .map((d, i) => [d, committees[i + 1]])
        )
        .join('path')
        .style('stroke', 'black')
        .style('stroke-width', 1)
        .attr('marker-end', 'url(#fdg-arrow)')
        .style('pointer-events', 'none')
        .attr('d', function(d, i) {
          const ddd = nodes.find((dd) => dd.id === d[0]);
          const dddd = nodes.find((dd) => dd.id === d[1]);
          return line([[ddd.x, ddd.y], [dddd.x, dddd.y]]);
        });

    if (path) {
    }

    const node = nodeGroup
      .append('circle')
      .attr('r', function(d) {
        return committees.indexOf(d.id) !== -1 && path ? 10 : 2;
      })
      .attr('fill', '#3d8feb')
      .call(this.drag(this.simulation));

    const miniNode =
      path &&
      nodeGroup
        .append('circle')
        .filter(function(d) {
          return committees.indexOf(d.id) !== -1;
        })
        .style('pointer-events', 'none')
        .attr('r', 3)
        .style('fill', 'black');

    const label =
      this.props.path &&
      svg
        .append('g')
        .selectAll('g')
        .data(nodes)
        .join('g')
        .filter((d) => {
          return committees.indexOf(d.id) !== -1;
        });

    label &&
      label
        .append('text')
        .attr('dy', 30)
        .text((d) => {
          let name = this.props.pathData.results.find(
            (dd) => dd.committee_id === d.id
          ).committee_name;
          name = name.indexOf('ZIMMERMAN') !== -1 ? 'DAYPAC' : name;

          return name;
        })
        .style('fill', 'rgb(255, 255, 255)')
        .style('stroke', 'rgb(255, 255, 255)')
        .style('stroke-width', 3)
        // .style('stroke-opacity', 0.8)
        .style('font-size', '10px')
        .attr('text-anchor', 'middle')
        .style('pointer-events', 'none');
    label &&
      label
        .append('text')
        .attr('dy', 30)
        .text((d) => {
          let name = this.props.pathData.results.find(
            (dd) => dd.committee_id === d.id
          ).committee_name;
          name = name.indexOf('ZIMMERMAN') !== -1 ? 'DAYPAC' : name;

          return name;
        })
        .style('font-size', '10px')
        .attr('text-anchor', 'middle')
        .style('pointer-events', 'none');

    // node.append('title').text((d) => d.id);

    this.simulation.on('tick', () => {
      link
        .attr('x1', (d) => d.source.x)
        .attr('y1', (d) => d.source.y)
        .attr('x2', (d) => d.target.x)
        .attr('y2', (d) => d.target.y);
      node.attr('cx', (d) => d.x).attr('cy', (d) => d.y);
      label && miniNode.attr('cx', (d) => d.x).attr('cy', (d) => d.y);
      label &&
        label
          .selectAll('text')
          .attr('x', (d) => d.x)
          .attr('y', (d) => d.y);
      label &&
        shortestPath.attr('d', function(d, i) {
          const ddd = nodes.find((dd) => dd.id === d[0]);
          const dddd = nodes.find((dd) => dd.id === d[1]);
          return line([[ddd.x, ddd.y], [dddd.x, dddd.y]]);
        });
    });
  }
  componentDidUpdate(prevProps) {
    this.simulation && this.simulation.stop();
    if (this.props.enabled && this.simulation) {
      d3.select(`#${this.id}`).html('');
    }
    if (this.props.enabled) {
      setTimeout(() => this.simulate(), 600);
    } else if (prevProps.enabled) {
      const nodes = this.simulation.nodes();
      this.props.handleAnchors(
        committees.map((d) => {
          const node = nodes.find((dd) => dd.id === d);
          return [node.x, node.y];
        })
      );
    }
  }
  render() {
    const { width, height, data, containerId } = this.context;

    return (
      <svg width={width} height={height}>
        <defs>
          <Arrow id='fdg-arrow' scale={1} />
          <Arrow flip />
        </defs>
        <g id={this.id} />
      </svg>
    );
  }
}

Graph.contextType = Context;

export default Graph;
